var React = require('react');

function Swoop180 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.5 583.333L0.5 875C161.763 875 292.5 744.413 292.5 583.333V291.667V194.444L292.5 169.1V0C131.493 0 0.5 130.844 0.5 291.667V437.491V583.333Z","fill":"currentColor"}));
}

Swoop180.defaultProps = {"width":"293","height":"875","viewBox":"0 0 293 875","fill":"none"};

module.exports = Swoop180;

Swoop180.default = Swoop180;
